<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";

    const orderStore = useOrderStore();

    const fulfillmentType = computed(() => {
        return orderStore.currentOrder.fulfillment.deliver
            ? "delivery"
            : "pickup";
    });
</script>
<template>
    <shared-labeled-field
        v-if="
            orderStore._config.enableDeliveries && orderStore.meta.pickupEnabled
        "
        v-slot="{ ariaLabelledby }"
        label="Levermethode"
    >
        <VRadioGroup
            v-model="orderStore.currentOrder.fulfillment.deliver"
            inline
            mandatory
            :hide-details="true"
            :aria-labelledby="ariaLabelledby"
        >
            <VRadio :value="true" label="Bezorgen" />
            <VRadio :value="false" label="Afhalen" />
        </VRadioGroup>
    </shared-labeled-field>
    <checkout-location-delivery
        v-if="orderStore.currentOrder.fulfillment.deliver"
    />
    <checkout-location-pickup v-else />
    <template v-if="orderStore.meta.fulfillmentFee">
        <VAlert type="info" class="mb-2" density="compact">
            {{
                $t(`checkout.location.fulfillmentFee.${fulfillmentType}`, {
                    fee: $n(orderStore.meta.fulfillmentFee / 100, "currency"),
                })
            }}
        </VAlert>
    </template>
</template>
